import React, { PropTypes, Component } from 'react';
import { Styles, IconButton } from 'material-ui';
import * as MaterialColors from 'components/Material/Styles/Colors';
import ScrollableContainer from 'components/ScrollableContainer';
import { StoreActions } from 'actions';

let { Colors, Text } = MaterialColors;
let { Spacing } = Styles;

let styles = {
  root: {
    position: 'relative',
    margin: 'auto',
    width: Spacing.desktopKeylineIncrement * 12
  },
  titles: {
    padding: Spacing.desktopGutterMini,
    textAlign: 'center'
  },
  avatar: {
    width: 24,
    height: 24,
    lineHeight: '24px',
    color: MaterialColors.Colors.fullWhite,
    fontWeight: 700,
    fontSize: '24px'
  }
};

class Wizard extends Component {
  static displayName = 'Wizard';

  state = {
    step: 0
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  gotoStep(step, enabled) {
    if (enabled) {
      this.setState({ step });
    }
  }

  next() {
    if (this.state.step < this.props.children.length) {
      this.setState({ step: this.state.step + 1 });
    }
  }

  finalize() {
    if (this.props.onFinalize) {
      this.props.onFinalize();
    }
  }

  getStepButtonStyle(completed = false, enabled = false) {
    let bgColor = { material: Colors.darkBondiBlue, text: 'Light' },
      borderColor = Colors.grey[600],
      enabledBgColor = Colors.coursio[500],
      enabledBorderColor = Colors.grey[600],
      textColor = Text[bgColor.text].text,
      enabledTextColor = Text[enabledBgColor.text].text,
      inactiveBgColor = Colors.grey[500],
      inactiveBorderColor = Colors.grey[300],
      inactiveTextColor = Text[inactiveBgColor.text].text;
    return {
      transition: 'all 0.5s linear',
      display: 'inline-block',
      height: Spacing.iconSize * 2,
      width: Spacing.iconSize * 2,
      lineHeight: Spacing.iconSize * 2 + 'px',
      borderRadius: Spacing.desktopToolbarHeight / 2,
      backgroundColor: completed
        ? bgColor.material
        : enabled ? enabledBgColor.material : inactiveBgColor.material,
      color: completed
        ? textColor.material
        : enabled ? enabledTextColor.material : inactiveTextColor.material,
      borderColor: completed
        ? borderColor.material
        : enabled ? enabledBorderColor.material : inactiveBorderColor.material,
      borderWidth: 1,
      borderStyle: 'solid',
      verticalAlign: 'middle'
    };
  }

  reset() {
    this.setState({ step: 0 });
  }

  getSeperatorStyle(completed = false) {
    let bgColor = Colors.darkBondiBlue,
      inactiveBgColor = Colors.grey[500].material;
    return {
      transition: 'all 0.5s linear',
      display: 'inline-block',
      height: Spacing.desktopGutterMini,
      width: Spacing.desktopGutter * 2,
      marginLeft: -Spacing.desktopGutterMini,
      marginRight: -Spacing.desktopGutterMini,
      backgroundColor: completed ? bgColor : inactiveBgColor,
      verticalAlign: 'middle'
    };
  }

  render() {
    let titles = [],
      activeStep,
      stepCount = this.props.children.length,
      previousCompleted = true,
      currentStepCompleted = false,
      nextButton;

    React.Children.forEach(this.props.children, (child, index) => {
      let { completed } = child.props,
        currentStep = index === this.state.step,
        enabled = false;
      enabled = previousCompleted;
      let icon = child.props.icon;
      titles.push(
        <IconButton
          key={index}
          style={this.getStepButtonStyle(
            completed,
            !completed && previousCompleted
          )}
          tooltipPosition="bottom-center"
          tooltip={child.props.title}
          onTouchTap={this.gotoStep.bind(this, index, enabled || completed)}
        >
          <WizardButton>{icon}</WizardButton>
        </IconButton>
      );
      if (index < stepCount - 1) {
        titles.push(
          <div key={'s-' + index} style={this.getSeperatorStyle(completed)} />
        );
      }
      if (currentStep) {
        if (completed || index === stepCount - 1) {
          currentStepCompleted = true;
        }
        activeStep = child;
      }
      previousCompleted = completed;
    });
    if (this.state.step === stepCount - 1) {
      nextButton = React.cloneElement(this.props.finalButton, {
        onTouchTap: this.finalize.bind(this)
      });
    } else {
      nextButton = React.cloneElement(this.props.nextButton, {
        onTouchTap: this.next.bind(this),
        disabled: !currentStepCompleted
      });
    }

    return (
      <div style={{ height: '100%' }}>
        <ScrollableContainer header={<div style={styles.titles}>{titles}</div>}>
          <div style={styles.root}>{activeStep}</div>
        </ScrollableContainer>
        {nextButton}
      </div>
    );
  }
}

class WizardStep extends Component {
  static displayName = 'WizardStep';

  render() {
    return <div>{this.props.children}</div>;
  }
}

class WizardButton extends Component {
  render() {
    return <div style={styles.avatar}>{this.props.children}</div>;
  }
}

export { Wizard, WizardStep };



// WEBPACK FOOTER //
// ./src/js/components/Wizard.js